export const iconFontAwesomeReligionHandsPraying = (
	<i className="fa-solid fa-hands-praying"></i>
);
